//

import React, { FC } from 'react'
import { USDCIcon } from './USDCIcon'
import { EUROCIcon } from './EUROCIcon'

interface Props {
  asset: string
}

export const AssetImage: FC<Props> = ({ asset }) => {
  switch (asset) {
    case 'EURC':
      return <EUROCIcon />
    case 'USDC':
    default:
      return <USDCIcon />
  }
}
